/* ThermoAspen Construction Drawings — server client 1.1.0 (TA Commercial Phase 3, 2 Nov 2026).
 * © 2026 ThermoAspen Ireland. All rights reserved.
 *
 * 1.1.0 (3 Nov 2026, Phase 5): inside the free Designer Summary (this page shown in the Summary's frame) the
 * client asks /apps/designer/summary, which needs no login, so the Summary's 3D view works for every visitor.
 * The Summary reply has no cut-list readiness. On the Construction Drawings page itself nothing changes.
 *
 * Replaces the 23 construction engine blocks on the Construction Drawings page (page.construction-test-temp).
 * The building geometry, the construction layers and the cut-list readiness are now worked out on the
 * ThermoAspen Designer server (through the Shopify App Proxy at /apps/designer/construction).
 *
 * This file only stands in for the three engine calls the Frame 3D viewer and the frame drawings make:
 *   ThermoAspenBuildingGeometryEngine.generate(project)          -> server sourceBuilding
 *   ThermoAspenConstructionCoreV1.build(project, {sourceBuilding}) -> server construction model
 *   ThermoAspenManufacturingDatasetV1.fromModels(project, ...)    -> server cut-list readiness
 * The calls are synchronous, so the first call for a design starts the server request and throws a quiet
 * "working" error (err.taServer = 'pending'). When the reply arrives, ThermoAspenBuildingEngineReady is
 * fired and both viewers rebuild from the stored reply. Login and server problems are shown in
 * #ta-construction-server-notice (err.taServer = 'login' / 'error').
 * The stove and chimney providers used to add their own Construction Sequence stages; the server now sends
 * those stage definitions (presentation only) with a yes/no per design, and they are registered here.
 * No construction rules live here.
 */
(function(W,D){
'use strict';
/* The Summary fills its frame with srcdoc, so the frame's address is about:srcdoc, not the page URL. */
function inSummary(){try{var f=W.frameElement;if(f&&/(^|\s)ta-sum-iframe(\s|$)/.test(String(f.className||'')))return true}catch(e){}try{return/(^|[?&])ta_embed=summary(&|$)/.test(String(W.location.search||''))}catch(e2){return false}}
var VERSION='1.1.0',SUMMARY=inSummary(),ENDPOINT=SUMMARY?'/apps/designer/summary':'/apps/designer/construction',TIMEOUT_MS=60000,KEEP=3,NOTICE_ID='ta-construction-server-notice';
if(W.ThermoAspenConstructionServerClientV1&&W.ThermoAspenConstructionServerClientV1.version===VERSION)return;

function clone(v){try{return JSON.parse(JSON.stringify(v))}catch(e){return v}}
function obj(v){return!!v&&typeof v==='object'&&!Array.isArray(v)}
function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
/* Same canonical JSON the server uses for its design fingerprint. */
function stable(v){if(v==null||typeof v!=='object')return JSON.stringify(v);if(Array.isArray(v))return'['+v.map(stable).join(',')+']';return'{'+Object.keys(v).sort().filter(function(k){return v[k]!==undefined}).map(function(k){return JSON.stringify(k)+':'+stable(v[k])}).join(',')+'}'}

/* Accepts what the page passes: a bare design, {project: design} (Project Runtime) or a ThermoAspenProject record. */
function designOf(p){
  if(!obj(p))return null;
  if(obj(p.schema)&&p.schema.name==='ThermoAspenProject'&&obj(p.design)&&obj(p.design.room))return p.design;
  if(obj(p.project)&&obj(p.project.room))return p.project;
  if(obj(p.design)&&obj(p.design.room))return p.design;
  return obj(p.room)?p:null;
}
/* The camera position and viewer version don't change the construction (same rule as the server). */
function keyOf(design){var d=clone(design);if(obj(d.exterior)){delete d.exterior.camera;delete d.exterior.viewerVersion}return stable(d)}

var entries=[],seq=0,last=null;
function find(key){for(var i=0;i<entries.length;i++)if(entries[i].key===key)return entries[i];return null}
function remember(e){entries=entries.filter(function(x){return x.key!==e.key});entries.unshift(e);if(entries.length>KEEP)entries.length=KEEP}

/* ---------- Construction Sequence stages sent by the server ---------- */
var stagesSeen=Object.create(null);
function byFingerprint(fp){for(var i=0;i<entries.length;i++)if(entries[i].reply&&entries[i].reply.designFingerprint===fp)return entries[i];return null}
function stageSupport(id){return function(ctx){var m=ctx&&ctx.constructionModel;if(!m)return true;var e=byFingerprint(m.designFingerprint),s=e&&e.stageSupport;return!!(s&&s[id]===true)}}
function registerStages(reply){
  var list=Array.isArray(reply&&reply.sequenceStages)?reply.sequenceStages:[],todo=[];
  list.forEach(function(x){var st=x&&x.stage;if(!st||!st.id||stagesSeen[st.id])return;stagesSeen[st.id]=1;var d=clone(st);d.supports=stageSupport(st.id);todo.push(d)});
  if(!todo.length)return;
  var Q=W.ThermoAspenConstructionSequenceV1;
  function add(Q){todo.forEach(function(d){try{Q.registerStage(d)}catch(e){}})}
  if(Q&&typeof Q.registerStage==='function')add(Q);
  else{if(!Array.isArray(W.__ThermoAspenConstructionSequenceQueue))W.__ThermoAspenConstructionSequenceQueue=[];W.__ThermoAspenConstructionSequenceQueue.push(add)}
}

function quiet(kind,msg){var e=new Error(msg);e.taServer=kind;return e}
function announce(){try{W.dispatchEvent(new CustomEvent('ThermoAspenBuildingEngineReady',{detail:{source:'designer-server',client:VERSION}}))}catch(e){}}

/* ---------- notice (working / log in / error) ---------- */
function noticeEl(){var n=D.getElementById(NOTICE_ID);if(n)return n;var host=D.getElementById('ta-structural-wall-3d');if(!host||!host.parentNode)return null;n=D.createElement('div');n.id=NOTICE_ID;n.hidden=true;host.parentNode.insertBefore(n,host);return n}
function showNotice(kind,html){var n=noticeEl();if(!n)return;if(!kind){n.hidden=true;n.innerHTML='';n.className='';return}n.className='tacs-notice tacs-notice--'+kind;n.innerHTML=html;n.hidden=false;var b=n.querySelector('[data-tacs-retry]');if(b)b.addEventListener('click',retry)}
function loginHtml(){var back=W.location.pathname+W.location.search;return'<strong>Log in to see the construction drawings</strong><span>The construction drawings are worked out for your ThermoAspen account. <a href="/account/login?return_url='+encodeURIComponent(back)+'">Log in</a></span>'}

/* ---------- server request ---------- */
function request(entry){
  var ctl=typeof AbortController==='function'?new AbortController():null,timer=ctl?setTimeout(function(){ctl.abort()},TIMEOUT_MS):0,mine=++seq;
  entry.state='pending';entry.startedAt=Date.now();
  showNotice('working','<strong>Working out the construction drawings…</strong><span>This usually takes a few seconds.</span>');
  fetch(ENDPOINT,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({design:entry.design}),signal:ctl?ctl.signal:undefined})
    .then(function(r){return r.text().then(function(t){var j=null;try{j=JSON.parse(t)}catch(e){}return{r:r,j:j}})})
    .then(function(x){
      if(timer)clearTimeout(timer);
      var j=x.j;
      if(!x.r.ok||!j||j.ok!==true){
        var login=!!(j&&j.loginRequired)||x.r.status===401&&!!(j&&j.loginRequired);
        entry.state=login?'login':'error';
        entry.error=login?'Log in to see the construction drawings.':(j&&j.error?String(j.error):'The server replied '+x.r.status+'.');
        return;
      }
      if(!j.sourceBuilding||!Array.isArray(j.sourceBuilding.structuralMembers)||!j.constructionModel||!j.constructionModel.layers){entry.state='error';entry.error='The server reply was incomplete.';return}
      entry.state='ready';entry.reply=j;entry.stageSupport={};(j.sequenceStages||[]).forEach(function(x){if(x&&x.stage&&x.stage.id)entry.stageSupport[x.stage.id]=x.supported===true});registerStages(j);entry.readiness={schemaName:'ThermoAspenManufacturingDatasetReadiness',source:'designer-server',designFingerprint:j.designFingerprint||null,linearMembers:(j.readiness||[]).map(function(r){return{id:r.id,mark:r.mark||null,readiness:{cutListReady:r.cutListReady===true,issues:Array.isArray(r.issues)?r.issues:[]}}})};
      last={designFingerprint:j.designFingerprint||null,engineBundle:j.engineBundle||null,stackId:j.stackId||null,cached:!!j.cached,timingMs:j.timingMs||null,roundTripMs:Date.now()-entry.startedAt,receivedAt:new Date().toISOString()};
    },function(err){
      if(timer)clearTimeout(timer);
      entry.state='error';entry.error=err&&err.name==='AbortError'?'The server took too long to reply.':'The server could not be reached.';
    })
    .then(function(){
      var top=entries[0]||entry; // the notice follows the latest design
      if(top.state==='ready')showNotice(null);
      else if(top.state==='login')showNotice('login',loginHtml());
      else if(top.state==='error')showNotice('error','<strong>The construction drawings could not be loaded.</strong><span>'+esc(top.error)+' <button type="button" data-tacs-retry>Try again</button></span>');
      if(mine!==seq&&entry.state!=='ready')return; // a newer request is under way
      announce();
    });
}

/* Returns the ready entry for this project, or throws a quiet error while it is on its way. */
function ready(p){
  var design=designOf(p);if(!design)throw new Error('No project design supplied.');
  var key=keyOf(design),e=find(key);
  if(!e){e={key:key,design:clone(design),state:'new'};remember(e);request(e)}
  if(e.state==='ready')return e;
  if(e.state==='login')throw quiet('login','Log in to see the construction drawings.');
  if(e.state==='error')throw quiet('error','The construction drawings could not be loaded.');
  throw quiet('pending','Working out the construction drawings…');
}
function retry(){entries=entries.filter(function(x){return x.state==='ready'});announce()}

/* ---------- stand-ins for the engine calls ---------- */
W.ThermoAspenBuildingGeometryEngine={
  version:'server-'+VERSION,architecture:'designer-server-v1',source:'designer-server',
  generate:function(p){return clone(ready(p).reply.sourceBuilding)}
};
W.ThermoAspenConstructionCoreV1={
  version:'server-'+VERSION,architecture:'designer-server-v1',source:'designer-server',
  build:function(p){return clone(ready(p).reply.constructionModel)}
};
W.ThermoAspenManufacturingDatasetV1={
  version:'server-'+VERSION,architecture:'designer-server-v1',source:'designer-server',
  fromModels:function(p){return clone(ready(p).readiness)}
};
W.ThermoAspenConstructionServerClientV1={
  version:VERSION,endpoint:ENDPOINT,summary:SUMMARY,retry:retry,
  status:function(){return{entries:entries.map(function(e){return{state:e.state,error:e.error||null,designFingerprint:e.reply&&e.reply.designFingerprint||null}}),last:clone(last)}}
};
})(window,document);
